import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

export const powerbiReport = gql`
  query PowerbiReport($businessId: String!, $type: PowerbiReportType!) {
    powerbiReport(businessId: $businessId, type: $type) {
      reportId
      reportName
      embedUrl
      embedToken
    }
  }
`

export const powerbiReportKey = getQueryNames(powerbiReport)[0]
